import React from 'react';
import { Modal, Box } from '@mui/material';
import PaymentMethod, { IPaymentMethod } from './PaymentForm'; // Import the PaymentMethod component
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useStripePromise } from '../../hook/useStripePromise';

interface IPaymentModal extends IPaymentMethod {
    open: boolean;
    onClose: () => void;
    amount?: number;
}

const PaymentModal: React.FC<IPaymentModal> = ({ open, onClose, amount, ...props }) => {
    const { themeStyle } = useThemeContext();
    const stripePromise = useStripePromise();

    const options: StripeElementsOptions = {
        mode: 'setup',
        currency: 'usd',
        setup_future_usage: 'off_session',
        appearance: {
            theme: themeStyle === 'dark' ? 'night' : 'flat',
        },
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="payment-modal-title"
            slotProps={{
                backdrop: {
                    style: {
                        backgroundColor: 'rgba(0,0,0,0.2)', // Set custom color with opacity
                        backdropFilter: 'blur(2px)', // Add blur effect
                    },
                },
            }}
            aria-describedby="payment-modal-description">
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: {
                        xs: '100vw',
                        sm: 500,
                    },
                    bgcolor: theme[themeStyle].deep_grey_lighter,
                    // boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: '75vh',
                    overflow: 'scroll',
                }}>
                <Elements stripe={stripePromise} options={options}>
                    <PaymentMethod onClose={onClose} {...props} />
                </Elements>
            </Box>
        </Modal>
    );
};

export default PaymentModal;
